// @ts-nocheck
import React from "react";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import { Check } from "lucide-react";
import { fontFamily } from "../../Constants/constants";
import rightArrowIcon from "../../../assets/new icons/extraction review/right arrow.svg";

interface ExtractionSuccessModalProps {
  open: boolean;
  successFilename?: string;
  onClose: () => void;
  onGoToExtractionReview: () => void;
}

const ExtractionSuccessModal: React.FC<ExtractionSuccessModalProps> = ({
  open,
  successFilename,
  onClose,
  onGoToExtractionReview,
}) => {
  return (
    <Modal
      open={open}
      onClose={null}
      aria-labelledby="extraction-success-modal-title"
      aria-describedby="extraction-success-modal-description"
      style={{
        border: "none",
        background: "transparent",
        boxShadow: "none",
      }}
    >
      <div
        style={{
          top: "50%",
          left: "50%",
          border: "none",
          transform: "translate(-50%, -50%)",
          position: "absolute",
          width: "460px",
          padding: "36px 32px 28px",
          outline: "none",
          backgroundColor: "white",
          boxShadow: "none",
          borderRadius: "16px",
          textAlign: "center",
        }}
      >
        {/* Close icon — top right */}
        <div
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            marginRight: 20,
            width: 24,
            height: 24,
            backgroundColor: "#a1dbf6",
            borderRadius: 8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <CloseIcon style={{ color: "#2AA7E0", fontSize: 14 }} />
        </div>

        {/* Top card — checkmark + filename + Extraction Successful */}
        <div
          style={{
            background: "#EAF6FC",
            borderRadius: 12,
            padding: "16px 20px",
            display: "flex",
            alignItems: "center",
            gap: 14,
            marginTop: 40,
            marginBottom: 20,
            textAlign: "left",
          }}
        >
          <div
            style={{
              width: 30,
              height: 30,
              backgroundColor: "#a1dbf6",
              borderRadius: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Check style={{ color: "#2AA7E0", fontSize: 14 }} />
          </div>
          <div>
            <div
              style={{
                fontFamily,
                fontSize: 14,
                fontWeight: 700,
                color: "#111",
                wordBreak: "break-all",
                marginBottom: 2,
              }}
            >
              {successFilename ?? ""}
            </div>
            <div
              style={{
                fontFamily,
                fontSize: 13,
                fontWeight: 500,
                color: "#2AA7E0",
              }}
            >
              Extraction Successful
            </div>
          </div>
        </div>

        {/* Description */}
        <p
          style={{
            fontFamily,
            fontSize: 16,
            color: "#667085",
            marginBottom: 28,
            lineHeight: 1.6,
            textAlign: "start",
          }}
        >
          Extraction completed. The file has been successfully pushed to Extraction Review.
        </p>

        {/* Buttons */}
        <div style={{ display: "flex", justifyContent: "center", gap: 14 }}>
          <Button
            disableElevation
            variant="outlined"
            style={{
              fontFamily,
              width: 160,
              height: 40,
              borderRadius: "3.56px",
              borderColor: "#2AA7E0",
              color: "#2AA7E0",
              textTransform: "none",
              fontWeight: 700,
              fontSize: 14,
            }}
            onClick={onClose}
          >
            Close
          </Button>

          <Button
            disableElevation
            variant="contained"
            disableRipple
            style={{
              fontFamily,
              width: 200,
              height: 40,
              borderRadius: "3.56px",
              backgroundColor: "#2AA7E0",
              color: "white",
              textTransform: "none",
              fontWeight: 700,
              fontSize: 14,
              gap: 8,
            }}
            endIcon={<img src={rightArrowIcon} alt="→" />}
            onClick={onGoToExtractionReview}
          >
            Extraction Review
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ExtractionSuccessModal;
